var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "#e3e3e3",
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M263.72-96Q234-96 213-117.15T192-168v-384q0-29.7 21.15-50.85T264-624h24v-96q0-79.68 56.23-135.84 56.22-56.16 136-56.16Q560-912 616-855.84T672-720v96h24q29.7 0 50.85 21.15T768-552v384q0 29.7-21.16 50.85T695.96-96zm.28-72h432v-384H264zm216.21-120Q510-288 531-309.21t21-51T530.79-411t-51-21T429-410.79t-21 51T429.21-309t51 21M360-624h240v-96q0-50-35-85t-85-35-85 35-35 85zm-96 456v-384z"
})));
export default SvgLock;